import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "form-attribute-error"
}


export default /*@__PURE__*/_defineComponent({
  __name: 'FormItem',
  props: {
    error: {}
  },
  setup(__props: any) {


const props = __props


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["form-item", { error: !!props.error }])
  }, [
    _renderSlot(_ctx.$slots, "default"),
    (props.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(props.error), 1))
      : _createCommentVNode("", true)
  ], 2))
}
}

})